@if (userHasAccess) {
  <div>
    @if (isRenewal) {
      <a [href]="planAdvisorRenewalSSOUrl" target="_blank" class="external-link">
        {{ planAdvisorLabel || "Plan Advisor - Renewal"}}
        <span class="material-symbols-outlined">open_in_new</span>
      </a>
    }
    @if (!isRenewal) {
      <a [href]="planAdvisorNewToBlueSSOUrl" target="_blank" class="external-link">
        {{ planAdvisorLabel || "Plan Advisor - New to Blue"}}
        <span class="material-symbols-outlined">open_in_new</span>
      </a>
    }
  </div>
}